module.exports = __webpack_public_path__ + "static/img/6.189c0af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/14/6.png
// module id = pDxu
// module chunks = 2